import { NgModule } from '@angular/core';
import { MomentModule } from 'angular2-moment';
import { ConsultationRoutingModule } from './consultation.routing';
import { SharedModule } from '../../shared/shared.module';
import { Component } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { DatePickerModule } from '../../components/date-picker/date-picker.module';
import { DatePipe } from '@angular/common';
import { MdAutocompleteModule, MdProgressSpinnerModule } from '@angular/material';
import { SearchPatientComponent } from './search-patient/search-patient.component';
import { PreviousWaitingRoomComponent } from './waiting-room/previous-waiting-room/previous-waiting-room.component';

import { WaitingRoomComponent } from './waiting-room/waiting-room.component';
import { CashSaleComponent } from './cash-sale/cash-sale.component';
import { GroupListComponent } from './waiting-room/group/group-list.component';
import { IndividualWaitingListComponent } from './waiting-room/individual/individual-list.component';
import { SelectMasterRecordComponent } from './result-search-patient/link-patient/select-master-record-popup.component';

import { ResultSearchPatientNonBaseComponent } from './result-search-patient/result-search-patient-nonbase.component';

import { EditGroupPopupComponent } from './waiting-room/group/edit-group-popup.component';
import { PayMethodPopupComponent } from './cash-sale/pay-method-popup.component';
import { ProductPopupComponent } from './cash-sale/product-popup.component';
import { CreditNotePopupComponent } from './cash-sale/credit-note-popup.component';
import { ViewSchedulePopupComponent } from './cash-sale/view-schedule-popup.component';
import { SelectClinicPopupComponent } from '../select-clinic/select-clinic-popup.component';
import { ResultSearchPatientComponent } from './result-search-patient/result-search-patient.component';
import { CreateGroupPopupComponent } from './waiting-room/group/create-group-popup.component';
import { ConsultationStatusPopupComponent } from './consultation-status/consultation-status-popup';
import { NoteInvoicePopupComponent } from './cash-sale/note-invoice.popup.component';
import { EmailInvoicePopupComponent } from './cash-sale/email-invoice-popup.component';
import { ConfirmPayMethodPopupComponent } from './cash-sale/confirm-pay-method-popup.component';
import { GroupTemplateListComponent } from './waiting-room/group-template/group-template-list.component';
import { ModifyGroupTemplateComponent } from './waiting-room/group-template/modify-group-template-popup.component';
import { AddToGroupTemplatePopupComponent } from './waiting-room/group-template/add-to-group-template-popup.component';
import { GroupTemplateInformationPopupComponent } from './waiting-room/group-template/group-template-information-popup/group-template-information-popup.component';
import { GroupTemplateInformationModule } from './waiting-room/group-template/group-template-information-popup/group-template-information/group-template-information.module';

@NgModule({
  declarations: [
    SearchPatientComponent,
    PreviousWaitingRoomComponent,
    WaitingRoomComponent,
    GroupListComponent,
    IndividualWaitingListComponent,
    CashSaleComponent,
    SelectMasterRecordComponent,
    ResultSearchPatientNonBaseComponent,
    EditGroupPopupComponent,
    PayMethodPopupComponent,
    ProductPopupComponent,
    CreditNotePopupComponent,
    ViewSchedulePopupComponent,
    SelectClinicPopupComponent,
    ResultSearchPatientComponent,
    ResultSearchPatientComponent,
    ConsultationStatusPopupComponent,
    NoteInvoicePopupComponent,
    CreateGroupPopupComponent,
    EmailInvoicePopupComponent,
    ConfirmPayMethodPopupComponent,
    GroupTemplateListComponent,
    ModifyGroupTemplateComponent,
    AddToGroupTemplatePopupComponent,
    GroupTemplateInformationPopupComponent
   ],
  imports: [
    ConsultationRoutingModule,
    SharedModule,
    MomentModule,
		DatePickerModule,
		MdProgressSpinnerModule,
    MdAutocompleteModule,
    GroupTemplateInformationModule
  ],
  entryComponents: [
    SelectMasterRecordComponent,
    EditGroupPopupComponent,
    PayMethodPopupComponent,
    ProductPopupComponent,
    CreditNotePopupComponent,
    ViewSchedulePopupComponent,
    SelectClinicPopupComponent,
    ConsultationStatusPopupComponent,
    NoteInvoicePopupComponent,
	  CreateGroupPopupComponent,
    EmailInvoicePopupComponent,
    ConfirmPayMethodPopupComponent,
    AddToGroupTemplatePopupComponent,
    ModifyGroupTemplateComponent,
    GroupTemplateInformationPopupComponent
  ],
  providers: [],
  bootstrap: []
})

export class ConsultationModule {
}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/consultation.module.ts